import Downloads from 'volto-base-addon/components/manage/Blocks/Downloads/Downloads';

const View = (props) => {
  return <Downloads showDisclaimer={true} showShareButton={false} />;
};

export default View;
